import {
  SUBMIT_CSAT,
  SUBMIT_CSAT_SUCCESS,
  SUBMIT_CSAT_FAILURE,
  HANDLE_CSAT,
  HANDLE_CSAT_SUCCESS,
  HANDLE_CSAT_FAILURE,
} from "./types";

export const submitCsat = (payload) => ({
  type: SUBMIT_CSAT,
  payload,
});

export const submitCsatSuccess = () => ({
  type: SUBMIT_CSAT_SUCCESS,
});

export const submitCsatFailure = () => ({
  type: SUBMIT_CSAT_FAILURE,
});

/** @param {{ action: 'LOGIN' | 'SKIP', interviewId?: string, productId?: string, onSuccess?: () => void, onFailure?: () => void }} payload */
export const handleCsat = (payload) => ({
  type: HANDLE_CSAT,
  payload,
});

export const handleCsatSuccess = (result) => ({
  type: HANDLE_CSAT_SUCCESS,
  payload: result,
});

export const handleCsatFailure = () => ({
  type: HANDLE_CSAT_FAILURE,
});
